import { createFileRoute } from "@tanstack/react-router";
import { TermsLayout } from "#/features/terms/components/terms-layout";

export const Route = createFileRoute("/_app/terms")({
	component: TermsLayout,
});
